import { getPlanPrices } from '@/hooks/use-currency';

/**
 * Computes the highest yearly savings percentage across all plans.
 *
 * Algorithm (identical in PricingPlans.tsx and PlansList.tsx before extraction):
 *   For each plan: savings = 1 - (yearlyPrice / (monthlyPrice * 12))
 *   Returns Math.round(max(savings) * 100).
 *
 * Plans with monthly = 0 or yearly = 0 are skipped to avoid division-by-zero
 * and non-finite results.
 *
 * @param plans  - Array of plan objects (raw API shape; `any[]` to match usage).
 * @param isBRL  - true → use BRL price fields; false → use USD price fields.
 * @returns      Integer percentage (e.g. 17 for "Save up to 17%"), or 0 if none found.
 */
export function computeMaxYearlySavingsPct(plans: any[], isBRL: boolean): number {
  let maxPct = 0;
  for (const p of plans) {
    const { value: monthly, valueYearly: yearly } = getPlanPrices(p, isBRL);
    if (monthly > 0 && yearly > 0) {
      const fullYear = monthly * 12;
      const frac = 1 - yearly / fullYear;
      if (isFinite(frac) && frac > maxPct) maxPct = frac;
    }
  }
  return Math.round(maxPct * 100);
}
